import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

// Switch accesible basado en un checkbox nativo. No usamos @radix-ui/react-switch
// para no agregar otra dependencia: el peer-checked de Tailwind cubre el uso.
export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, checked, ...props }, ref) => (
    <label className={cn('relative inline-flex h-6 w-11 cursor-pointer items-center', className)}>
      <input
        ref={ref}
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        {...props}
      />
      <span className="absolute inset-0 rounded-full bg-input transition-colors peer-checked:bg-primary peer-disabled:cursor-not-allowed peer-disabled:opacity-50" />
      <span className="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-background shadow transition-transform peer-checked:translate-x-5" />
    </label>
  ),
)
Switch.displayName = 'Switch'
